'use strict';

angular.module('domain.voice', ['ngRoute', 'upResources', 'security.authorization']).config([
	'$stateProvider',
	'$upModalProvider',
	function ($stateProvider, $upModalProvider) {
		$stateProvider.state('phoneCalls', {
			url: '/:customerId/phoneCalls/'
		});

		$upModalProvider.modal('openCall', {
			templateUrl: require('App/upsales/domain/voice/views/openCall.html?file'),
			style: 'form-sm info phonecall-modal',
			controller: 'openCall as openCall',
			resolve: {
				meta: function ($modalParams, Account, AppService) {
					if (!$modalParams.client?.id) {
						return null;
					}
					return Account.customer(AppService.getCustomerId()).get($modalParams.client.id);
				}
			}
		});
	}
]);
